import {PokusExpDataShape} from '../../hotels-reducers/hotels-common-reducer/src/types';

const commonExpData = {
  APE: 10,
  PAH: 5,
  PAH5: 'T',
  WPAH: 'F',
  BNPL: 'T',
  MRS: 'T',
  PDO: 'PN',
  MCUR: 'T',
  ADDON: 'T',
  CHPC: 'T',
  AARI: 'T',
  NLP: 'Y',
  RCPN: 'T',
  PLRS: 'T',
  MMRVER: 'V3',
  BLACK: 'T',
  IAO: 'T',
  EMIDT: '1',
  AIP: 'T',
  APT: 'T',
  SRRP: 'T',
  SOU: 'T',
  CV2: 'T',
  MLOS: 'T',
  NHL: 'T',
  detailV3: 'T',
  ADC: 'T',
  OCCFCNR: 'F',
  HFC: 'T',
  VIDEO: 0,
  LSTNRBY: 'T',
  RRR: 3,
  FBP: 'T',
  FBS: 'A',
  HRNB: 3,
  EMI: 'F',
  TFT: 'T',
  GEC: 'A',
  SMC: 'F',
  SPCR: 2,
  CRF: 'B',
  LSOF: 'T',
  HPI: 'true',
  EFF: 'F',
  GBE: 'F',
  HAFC: 'T',
  BNPL0: 'T',
  DPCR: 1,
  CGC: 'T',
  FLTRPRCBKT: 'T',
  ST: 'T',
  SOC: 'T',
  ADDV: 'F',
  HIS: 1234,
  HSTV2: 'T',
  PLGI: 'T',
  bnplNewVariant: 'true',
  unificationReviewV2: 'true',
  NEWTY: 'T',
  streaks_hermes: 1,
  HSCFS: 4,
  AALV2: 'T',
  GALLERYV2: 'T',
  GRPN: 'T',
  RTBC: 'T',
  SSV2: 'T',
  SPKG: 'T',
  MBDTC: 'T',
  giShowIntlRoaming: 'true',
  UGCV2: 'T',
  MEDIAV2: 'T',
};

type Props = {
  pokus?: PokusExpDataShape;
  additionalData?: Record<string, any>;
};

export const getExperimentData = (props: Props = {}): string => {
  const {pokus = {} as PokusExpDataShape, additionalData = {}} = props;
  let expData = {...commonExpData};

  expData = {...expData, ...additionalData};

  return `{${Object.entries(expData)
    .map(([key, value]) => `${key}:${value}`)
    .join(',')}}`;
};
